import api from "@services/api-service";
import queryParams from "@services/repository-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    usuario: {},
    access_token: false,
    expires_in: false,
    refresh_token: false,
    token_type: false,
    permissoes: {}
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    SET_LOGIN_LOADING: (state, isLoading) => {
      state.login.loading = isLoading;
    },

    SET_LOGIN: (
      state,
      { access_token, expires_in, refresh_token, token_type }
    ) => {
      state.login.access_token = access_token;
      state.login.expires_in = expires_in;
      state.login.refresh_token = refresh_token;
      state.login.token_type = token_type;
    },

    SET_USUARIO: (state, usuario) => {
      state.login.usuario = usuario;
    },

    LOGOUT: state => {
      state.login.usuario = {};
      state.login.access_token = false;
      state.login.expires_in = false;
      state.login.refresh_token = false;
      state.login.token_type = false;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    isLoadingLogin: state => () => {
      return state.login.loading;
    },
    getUsuarioId: state => () => {
      return state.login.usuario.id;
    },
    getUsuarioEmail: state => () => {
      return state.login.usuario.email;
    },
    getUsuarioNome: state => () => {
      return state.login.usuario.nome;
    },
    getUsuarioTipo: state => () => {
      return state.login.usuario.usuarioTipo;
    },
    getUsuarioAssociacao: state => () => {
      return state.login.usuario.associacao;
    },
    getUsuarioEntidade: state => () => {
      return state.login.usuario.entidade;
    },
    getUsuarioParceiro: state => () => {
      return state.login.usuario.parceiro;
    },
    getUsuario: state => () => {
      return state.login.usuario;
    },
    getAccessToken: state => () => {
      return state.login.access_token;
    },
    hasPermission: state => permissao => {
      try {
        return state.login.usuario.usuarioTipo.permissoes.includes(permissao);
      } catch (error) {
        return false;
      }
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_LOGIN_ASYNC: function({ commit, dispatch }, dados) {
      commit("SET_LOGIN_LOADING", true);
      return new Promise((resolve, reject) => {
        api()
          .post("auth/login", {
            ...dados,
            grant_type: "password",
            client_id: process.env.VUE_APP_CD_CLIENT_ID,
            client_secret: process.env.VUE_APP_CD_CLIENT_SECRET,
            scope: "*"
          })
          .then(response => {
            commit("SET_LOGIN", {
              access_token: response.data.access_token,
              expires_in: response.data.expires_in,
              refresh_token: response.data.refresh_token,
              token_type: response.data.token_type
            });

            dispatch("showNotification", {
              time: 3000,
              title: "Autenticado com sucesso!",
              text: "Carregando sistema...",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "bottom-center"
            });

            api()
              .get("auth/meus-dados", {
                params: queryParams({
                  relationships: [
                    "associacao",
                    "entidade",
                    "parceiro",
                    "usuarioTipo"
                  ]
                })
              })
              .then(response => {
                commit("SET_USUARIO", response.data.data);
                resolve(response);
              })
              .catch(error => reject(error))
              .finally(() => commit("SET_LOGIN_LOADING", false));
          })
          .catch(error => {
            reject(error);
            commit("SET_LOGIN_LOADING", false);
          });
      });
    },

    LOGOUT: function({ state, commit, dispatch }) {
      commit("LOGOUT", true);
      if (state.login.access_token) {
        dispatch("showNotification", {
          time: 3000,
          title: "Desconectado com sucesso!",
          text: "Para entrar novamente, informe seu usuário e senha",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "bottom-center"
        });
      }
    }
  }
};

export default store;
